import { updateSurveyStatus } from 'utils/generals';

// Catalog of instrumented moments. Developer adds entries here when a new
// hookable point is added to the codebase. After registering here, admins
// can create surveys for that moment via the admin panel without any more code.
export const SURVEY_MOMENTS = {
  user_login: {
    label: 'Al iniciar sesión',
    process: 'LOGIN',
    context: 'none',
  },
  course_entered: {
    label: 'Al ingresar a un curso',
    process: 'ENTER_COURSE',
    context: 'course',
  },
  evaluation_submitted: {
    label: 'Al enviar una evaluación',
    process: 'EVALUATE',
    context: 'course',
  },
  video_upload_started: {
    label: 'Al completar subida de video',
    process: 'UPLOAD_VIDEO',
    context: 'course',
  },
  survey_closed_in_course: {
    label: 'Al cerrar encuesta dentro de un curso',
    process: 'COURSE_COMPLETED',
    context: 'course',
  },
  course_completed: {
    label: 'Al completar todas las etapas del curso',
    process: 'COURSE_COMPLETED',
    context: 'course',
  },
  dashboard_viewed: {
    label: 'Al visualizar el dashboard',
    process: 'DASHBOARD_VIEW',
    context: 'none',
  },
};

/**
 * Fire a survey moment. The Rails resolver decides whether there is an active
 * survey for this process, whether the user qualifies, and whether they have
 * already answered it — so this call is always safe to make.
 *
 * @param {string} momentKey - Key from SURVEY_MOMENTS catalog
 * @param {{ courseId?: string|number }} context
 */
export function fireSurveyMoment(momentKey, context = {}) {
  const moment = SURVEY_MOMENTS[momentKey];
  if (!moment) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[Survey] Unknown moment key: "${momentKey}". Register it in utils/surveyEngine.js`);
    }
    return;
  }
  const courseId = context.courseId ?? null;
  updateSurveyStatus(true, moment.process, courseId);
}
